import Axios from '../baseApi';
export default {
  async fetch() {
    return await Axios.get('/api-article/delivery-remark/v1');
  }
}
